import AutoRedactContent from "../../../../src/pages/pricing/contact/sales/auto-redact/auto-redact-content.md";
import { AutoRedact } from "../../../../src/components/auto-redact";
import * as React from 'react';
export default {
  AutoRedactContent,
  AutoRedact,
  React
};